export const HOME_PATH = '/';

/* ------------------- */
/* --- PLAYER --- */

export const INDEX_PLAYER_PATH = '/pj';
export const PV_PLAYER_SUFFIX = '/pv';
export const CONFIG_PLAYER_SUFFIX = '/configuration';
export const CUSTOMIZATION_PLAYER_SUFFIX = '/customisation';

export const CUSTOMIZATION_PLAYER_PATH = INDEX_PLAYER_PATH + CUSTOMIZATION_PLAYER_SUFFIX;
export const CONFIG_PLAYER_PATH = INDEX_PLAYER_PATH + CONFIG_PLAYER_SUFFIX;
export const PV_PLAYER_PATH = INDEX_PLAYER_PATH + PV_PLAYER_SUFFIX;

/* ------------------- */
/* --- MASTER --- */

export const INDEX_MASTER_PATH = '/mj';
export const EPISODE_MASTER_SUFFIX = '/episode';
export const CONFIG_MASTER_SUFFIX = '/configuration';
export const PLAYLIST_MASTER_SUFFIX = '/playlist';
export const CREATURE_MASTER_SUFFIX = '/creature';
export const WIKI_MASTER_SUFFIX = '/wiki';
export const DICE_MASTER_SUFFIX = '/de';
export const FAQ_MASTER_SUFFIX = '/faq';

export const EPISODE_MASTER_PATH = INDEX_MASTER_PATH + EPISODE_MASTER_SUFFIX;
export const CONFIG_MASTER_PATH = INDEX_MASTER_PATH + CONFIG_MASTER_SUFFIX;
export const PLAYLIST_MASTER_PATH = INDEX_MASTER_PATH + PLAYLIST_MASTER_SUFFIX;
export const CREATURE_MASTER_PATH = INDEX_MASTER_PATH + CREATURE_MASTER_SUFFIX;
export const WIKI_MASTER_PATH = INDEX_MASTER_PATH + WIKI_MASTER_SUFFIX;
export const DICE_MASTER_PATH = INDEX_MASTER_PATH + DICE_MASTER_SUFFIX;
export const FAQ_MASTER_PATH = INDEX_MASTER_PATH + FAQ_MASTER_SUFFIX;
